module.exports = "/_next/static/images/Hyundai-a114ecd86422b75839e20052199e8058.svg";